import { Badge, BlockStack, Page, SkeletonBodyText, Text } from '@shopify/polaris';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import JourneyModal from './journey.modal';

import { useMutateGetJourney } from 'queries/journey.query';

import __helpers from 'helpers/index';

export default function JourneyDetail() {
  let { journey_id } = useParams();

  const history = useNavigate();
  const [newModelactive, setNewModelactive] = useState(false);
  const toggleNewActive = useCallback(() => setNewModelactive((active) => !active), []);
  const { mutateAsync: getJourney, data: entity, isPending, isSuccess } = useMutateGetJourney();

  useEffect(() => {
    getJourney(journey_id);
  }, [journey_id]);

  // Chuyển đổi giây sang giờ, phút, giây
  const formatTime = (_minutes: number) => {
    const seconds = _minutes * 60;
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return [hours > 0 ? `${hours}h` : '', minutes > 0 ? `${minutes}p` : hours > 0 ? '0p' : ''].filter(Boolean).join(' ');
  };

  return (
    <>
      <Helmet>
        <title>{entity?.journey_name}</title>
      </Helmet>
      <Page
        compactTitle
        titleMetadata={
          <>
            <Badge tone="success">{`${__helpers.formatNumberWithCommas(entity?.journey_default_price ?? 0)} VND`}</Badge>
            {entity?.is_default === 1 && <Badge tone="magic">Mặc định</Badge>}
          </>
        }
        subtitle={`Tổng thời gian: ${formatTime(entity?.journey_total_time ?? 0)} - Khoảng cách hành trình ${entity?.journey_distance || 0} km - Xe mặc định: ${entity?.seating?.seating_name ?? '--'}`}
        title={`${entity?.journey_name}`}
        backAction={{
          onAction: () => history('/journey'),
        }}
        primaryAction={{
          content: 'Sửa hành trình',
          onAction: () => toggleNewActive(),
        }}
      >
        {isPending && <SkeletonBodyText />}
        {isSuccess && <BlockStack gap="400"></BlockStack>}
        <br />
        <br />
      </Page>

      {
        <>
          <JourneyModal
            show={newModelactive}
            currentVehicleID={BigInt(journey_id)}
            onClose={() => {
              setNewModelactive(false);
              getJourney(journey_id);
            }}
          />
        </>
      }
    </>
  );
}

